<template>
  <b-modal id="signatureModal" size="lg" title="Please sign here" ok-only ok-variant="secondary" hide-footer>
    <div class="col-12 mt-2">
      <VueSignaturePad
        id="signature"
        width="100%"
        height="500px"
        ref="signaturePad"
        :options="{
          onBegin: () => {
            this.$refs.signaturePad.resizeCanvas()
          },
        }"
      />

      <br />

      <div>
        <el-button @click="save">Save</el-button>
        <el-button @click="undo">Undo</el-button>
        <el-button @click="clear">Clear</el-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import VueSignaturePad from 'vue-signature-pad'
Vue.use(VueSignaturePad)
export default {
  methods: {
    async save() {
      const { data } = this.$refs.signaturePad.saveSignature()
      if (data) this.$emit('save', data)
      this.$bvModal.hide('signatureModal')
    },
    async undo() {
      this.$refs.signaturePad.undoSignature()
    },
    async clear() {
      this.$refs.signaturePad.clearSignature()
    },
  },
}
</script>
